var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M9.333 4.667h-.666V3.333a3.335 3.335 0 0 0-6.667 0v1.334h-.667C.6 4.667 0 5.267 0 6v6.667C0 13.4.6 14 1.333 14h8c.734 0 1.334-.6 1.334-1.333V6c0-.733-.6-1.333-1.334-1.333m-4 6C4.6 10.667 4 10.067 4 9.333 4 8.6 4.6 8 5.333 8c.734 0 1.334.6 1.334 1.333 0 .734-.6 1.334-1.334 1.334m-2-6V3.333c0-1.106.894-2 2-2 1.107 0 2 .894 2 2v1.334z"
})));
export { SvgLockIcon as ReactComponent };
export default __webpack_public_path__ + "0cd499461189089fa7d0bb22dc46ea05.svg";